/**
 * The home page's pointer to QA Talent. New copy, kept out of home.ts, whose
 * strings are client-approved and verbatim. Compact on purpose: it must not
 * compete with the page's own proposition.
 */
export const homeTalentBand = {
  eyebrow: 'QA Talent',
  heading: 'Need QA people rather than a consulting engagement?',
  body: 'We can help you hire Automation QA, Manual QA and QA leadership talent, with no recruitment fee.',
  cta: { label: 'Hire QA Talent', href: '/for-employers' },
} as const;
